import React, { useEffect, useRef, useState } from 'react';
import '../css/home.css';
import { useNavigate} from 'react-router-dom';

// Images
// import education from '../image/education.png';
// import readingbook from '../image/readingbook.jpg';
// import speech_bubble from '../image/speech_bubble.png';
import chat_frontend from '../image/chat_frontend_19march.png';
import twentfour7 from '../image/247.png';
import cultural_context from '../image/cultural_context.png';
import intelligent from '../image/intelligent.png';
import personalised_learning from '../image/Personalised_learning.png';
import pronunciation_coach from '../image/Pronounciation_coach.png';
import vocabulary_builder from '../image/Vocabulary_builder.png';

import students from '../image/students.png';
import proffesionals from '../image/proffesionals.png';
import travellers from '../image/travellers.png';

// Import the new Hero component
import Hero from './Hero';

const Home = () => {
  // Refs for animation elements
  const demoRef = useRef(null);
  const featuresRef = useRef(null);
  const howItWorksRef = useRef(null);
  const useCasesRef = useRef(null);
  const ctaRef = useRef(null);
  const [activeTab, setActiveTab] = useState('students');
  const navigate = useNavigate();

  const handleStartlearning = () => {
    navigate('/login?signup=true');
  };
  
  // Animation on scroll
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);
    
    // Observe elements
    const elements = [
      demoRef.current, 
      featuresRef.current,
      howItWorksRef.current,
      useCasesRef.current,
      ctaRef.current
    ];
    
    elements.forEach(el => {
      if (el) observer.observe(el);
    });
    
    return () => {
      elements.forEach(el => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  return (
    <div className="english-app">
      {/* Hero Section */}
      <Hero />

      {/* Demo Section */}
      <section ref={demoRef} className="demo-section">
        <div className="container">
          <div className="section-header">
            <h2>See How It Works</h2>
            <p>Experience natural conversations that help you improve with every interaction</p>
          </div>
          <div className="demo-container">
            <div className="demo-video">
              <div className="video-frame">
                <div className="video-placeholder">
                  <video 
                    controls
                    width="100%"
                    poster={chat_frontend}
                    preload="metadata"
                  >
                    <source src="https://storage.googleapis.com/fluentalk-bucket/Demo_Video1.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
            <div className="demo-steps">
              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Choose Your Topic</h3>
                  <p>Select from everyday situations, academic topics, or professional scenarios</p>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Natural Conversation</h3>
                  <p>Speak naturally with our AI assistant that adapts to your level</p>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Get Instant Feedback</h3>
                  <p>Receive helpful corrections on pronunciation, grammar, and vocabulary</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section ref={featuresRef} className="features-section">
        <div className="container">
          <div className="section-header">
            <h2>Powerful Learning Features</h2>
            <p>Tools designed to maximize your English improvement</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <img src={intelligent} alt="Conversation icon" className="icon-placeholder" />
                {/* Comment: Replace with an SVG icon showing speech bubbles or conversation flow */}
              </div>
              <h3>Intelligent Conversations</h3>
              <p>
                Natural dialogues with contextual responses that adapt to your 
                speaking style and proficiency level.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={pronunciation_coach} alt="Pronunciation icon" className="icon-placeholder" />
                {/* Comment: Replace with an SVG icon showing sound waves or pronunciation guidance */}
              </div>
              <h3>Pronunciation Coach</h3>
              <p>
                Real-time guidance on speaking improvement with gentle 
                corrections to help you sound more natural.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={personalised_learning} alt="Learning path icon" className="icon-placeholder" />
                {/* Comment: Replace with an SVG icon showing a customized path or roadmap */}
              </div>
              <h3>Personalized Learning</h3>
              <p>
                Custom learning paths that adapt to your strengths and 
                weaknesses, focusing on areas that need improvement.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={vocabulary_builder} alt="Vocabulary icon" className="icon-placeholder" />
                {/* Comment: Replace with an SVG icon showing vocabulary or word learning */}
              </div>
              <h3>Vocabulary Builder</h3>
              <p>
                Expand your word knowledge through contextual learning
                and spaced repetition techniques.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={cultural_context} alt="Cultural icon" className="icon-placeholder" />
                {/* Comment: Replace with an SVG icon showing cultural exchange or understanding */}
              </div>
              <h3>Cultural Context</h3>
              <p>
                Learn appropriate expressions and cultural nuances for
                different situations and regions.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={twentfour7} alt="Practice icon" className="icon-placeholder" />
                {/* Comment: Replace with an SVG icon showing practice or repetition concept */}
              </div>
              <h3>24/7 Practice</h3>
              <p>
                Practice anytime you want without scheduling or waiting,
                with unlimited conversations available.
              </p>
            </div>
          </div>
        </div>
      </section>

      

      {/* Use Cases Section */}
      <section ref={useCasesRef} className="use-cases-section">
        <div className="container">
          <div className="section-header">
            <h2>Who Can Benefit</h2>
            <p>English practice designed for everyone's needs</p>
          </div>
          <div className="use-cases-tabs">
            <div className="tabs-navigation">
              <button 
                className={`tab-button ${activeTab === 'students' ? 'active' : ''}`} 
                onClick={() => setActiveTab('students')}
              >
                Students
              </button>
              <button 
                className={`tab-button ${activeTab === 'professionals' ? 'active' : ''}`}
                onClick={() => setActiveTab('professionals')}
              >
                Professionals
              </button>
              <button 
                className={`tab-button ${activeTab === 'travelers' ? 'active' : ''}`}
                onClick={() => setActiveTab('travelers')}
              >
                Travelers
              </button>
            </div>
            
            <div className="tabs-content">
              {/* STUDENTS TAB */}
              <div className={`tab-pane ${activeTab === 'students' ? 'active' : ''}`} id="students">
                <div className="use-case-content">
                  <div className="use-case-image">
                    <img src={students} alt="Student using app" />
                    {/* Comment: Replace with an illustration of a student using the app for academic English */}
                  </div>
                  <div className="use-case-text">
                    <h3>Perfect for Students</h3>
                    <ul className="benefit-list">
                      <li>Prepare for classroom discussions and presentations</li>
                      <li>Practice academic vocabulary and expressions</li>
                      <li>Get help with pronunciation of difficult terms</li>
                      <li>Build confidence before speaking in class</li>
                      <li>Prepare for English proficiency exams</li>
                    </ul>
                    <div className="testimonial">
                      <p>"This app helped me gain the confidence to participate more in my university classes. My professors have noticed the improvement!"</p>
                      <span className="testimonial-author">— Maria, ESL Student</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* PROFESSIONALS TAB */}
              <div className={`tab-pane ${activeTab === 'professionals' ? 'active' : ''}`} id="professionals">
                <div className="use-case-content">
                  <div className="use-case-image">
                    <img src={proffesionals} alt="Professional using app" />
                    {/* Comment: Replace with an illustration of a professional using the app for business English */}
                  </div>
                  <div className="use-case-text">
                    <h3>Essential for Professionals</h3>
                    <ul className="benefit-list">
                      <li>Practice business vocabulary and expressions</li>
                      <li>Prepare for meetings and presentations</li>
                      <li>Improve email and communication skills</li>
                      <li>Build confidence for international calls</li>
                      <li>Learn industry-specific terminology</li>
                    </ul>
                    <div className="testimonial">
                      <p>"I use this app before important client meetings. It's helped me communicate more clearly and professionally in my international role."</p>
                      <span className="testimonial-author">— Takashi, Marketing Executive</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* TRAVELERS TAB */}
              <div className={`tab-pane ${activeTab === 'travelers' ? 'active' : ''}`} id="travelers">
                <div className="use-case-content">
                  <div className="use-case-image">
                    <img src={travellers} alt="Traveler using app" />
                    {/* Comment: Replace with an illustration of a traveler using the app */}
                  </div>
                  <div className="use-case-text">
                    <h3>Ideal for Travelers</h3>
                    <ul className="benefit-list">
                      <li>Learn practical travel conversations</li>
                      <li>Practice ordering food, asking directions, and more</li>
                      <li>Build confidence for real-world interactions</li>
                      <li>Learn cultural expressions and etiquette</li>
                      <li>Get help with emergency situations</li>
                    </ul>
                    <div className="testimonial">
                      <p>"I practiced common travel scenarios before my trip to London. I felt so much more confident navigating the city and talking with locals!"</p>
                      <span className="testimonial-author">— Carlos, Travel Enthusiast</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call To Action Section */}
      <section ref={ctaRef} className="cta-section">
        <div className="cta-pattern"></div>
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your English?</h2>
            <p>Start having meaningful conversations today and take your English skills to the next level.</p>
            <button className="cta-button">Begin Your Journey <span className="arrow">→</span></button>
            <div className="social-proof">
            <div className="users-count">
                <span className="count">5,000+</span> Active Users
              </div>
              <div className="rating">
                <div className="stars">★★★★★</div>
                <span className="rating-text">4.06/5 Average Rating</span>
              </div>
              <div className="reviews-count">
                <span className="count">350+</span> Positive Reviews
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Floating chat button */}
      <div className="floating-chat-button"
        onClick={handleStartlearning}>
        <span className="chat-label">Try the Demo</span>
      </div>

    </div>
  );
};

export default Home;